export default __webpack_public_path__ + "static/media/h5-home-banner3.a0e25c18.png";